import { apiHelper, PromiseHandler } from "../redux/apiHelper";
const deleteLogsById = (id) =>
  PromiseHandler(apiHelper("post", `/api/admin/logs/delete/${id}`));
const getLogs = () => PromiseHandler(apiHelper("get", "/api/admin/logs/list"));
const getLogsById = (id) =>
  PromiseHandler(apiHelper("get", `/api/admin/logs/get/${id}`));
export { deleteLogsById, getLogs, getLogsById };
